<template>
  <li>
    <div class="contentsWrap reviewCard reviews_wrap">
      <div class="location">
        <ol>
          <li>{{ community.area.island_name }}</li>
          <li>{{ community.area.area_name }}</li>
        </ol>
      </div>
      <a :href="'/shop/' + community.large_category_id + '/' + community.shop_id + '/community'" class="name">{{ shopName }}</a>
      <hr />
      <div class="iconWithName">
        <div class="icon">
          <img :src="src(community.user.image_url)">
        </div>
        <div class="name">{{ community.user.name }}</div>
      </div>
      <div class="text">
        <h3 class="title">{{ community.title }}</h3>
        <slide-photos
            :photos="community.photos"
            :imagePath="imagePath"
            customClass="communityPhoto"
        ></slide-photos>
        <p class="content" v-if="!open">
          {{ content }}
          <span class="more" v-if="community.content.length > contentLength" @click.prevent="open = !open">…もっと見る</span>
        </p>
        <p class="content" v-if="open">
          {{ community.content }}
          <span class="more close" @click.prevent="open = !open">閉じる</span>
        </p>
        <div class="date">{{ community.created_at }}</div>
      </div>
    </div>
    <div class="comments">
      <mypage-community-comment
          :community="community"
          :comments="community.approval_comments"
          :image-path="imagePath"
          :user-id="userId">
      </mypage-community-comment>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    area: Object,
    community: Object,
    shopName: String,
    imagePath: String,
    userId: Number
  },
  data: () => ({
    contentLength: 50,
    open: false
  }),
  computed: {
    content() {
      return this.community.content.substr(0, this.contentLength)
    }
  },
  methods: {
    src(url) {
      if (this.$_.isEmpty(url)) {
        return '/img/aloco_img_2.svg'
      } else {
        return this.imagePath + url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mypage.communities {
  .contentsWrap {
    border-radius: 10px 10px 0 0;

    .iconWithName {
      padding-top: 16px;
    }
    .content {
      white-space: pre-line;
      height: auto;
      overflow: unset;
      max-height: none;
    }
  }
}
</style>
